import { PermissionNameEnum } from '@Types/permissions';
import AddSchedule from '../../pages/Report/ScheduleReports/AddSchedule';
const reportRouter = [
  {
    path: '/report/addSchedule',
    element: AddSchedule,
    name: 'side.group.report',
    permission: PermissionNameEnum.report,
  },
  {
    path: '/report/addSchedule/:id',
    element: AddSchedule,
    name: 'side.group.report',
    permission: PermissionNameEnum.report,
  },
];

export default reportRouter;
